import React from 'react'
import axios from "axios";
import Api from "../../../assets/js/utils/Api";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
import sendLimitModalStyle from "../../../assets/jss/user/sendLimitModalStyle.jsx";
import LoaderComponent from '../Loader';
import { Link as RouterLink } from "react-router-dom";
import ConfirmationModal from './ConfirmationModal';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const SendLimitModal = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;

        this.state = {
            activateSaving: false,
            subscriptionModal: false,
            subscriptionUserData: null,
            showSubscriptionError: false,
            errorMessage: ''
        }
    }
    onSubscriptionModal(status = false){
        this.setState({
            subscriptionModal: status,
            showSubscriptionError: false,
            errorMessage: ''
        });

        if(this.state.subscriptionUserData !== null){
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(this.state.subscriptionUserData));
            let newUser = Api.prepareMemberObject(this.state.subscriptionUserData);

            this.setState({
                subscriptionUserData: null,
            })
            
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }
    }
    subscriptionTrialEnd(){
        this.setState({
            activateSaving: true
        })

        const source = axios.CancelToken.source();
        Api.subscriptionTrialEnd({}, source).then((data) => {
            this.setState({
                activateSaving: false,
                subscriptionUserData: data.user,
            });
            // localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
            // let newUser = Api.prepareMemberObject(data.user);
            // this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            this.setState({
                showSubscriptionError: true,
                errorMessage: err.message,
                activateSaving: false
            });
        });
    }
    getVerifyUrl(){
        const { user } = this.store.getState();
        if(user.hasOwnProperty('basic_info_filled') && !user.basic_info_filled){
            return "/user/profile";
        }

        return "/user/security";
    }
    render() {
        const { activateSaving, subscriptionModal, subscriptionUserData, showSubscriptionError, errorMessage,  } = this.state;
        const { classes } = this.props;
        const { user } = this.store.getState();

        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="processingModal-modal-slide-title"
                aria-describedby="processingModal-modal-slide-description"
            >
                <DialogTitle
                    id="processingModal-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                >
                    <Button
                        simple
                        className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.props.onClose()}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle}>Send Limit Notice</h4>
                    {
                        activateSaving ?
                            <LoaderComponent color="custom" align="right" size={20} /> 
                        :  user.hasOwnProperty('is_subscription_on_trial') && user.is_subscription_on_trial ?
                            <Button className="activate-btn" color="success" size="sm" onClick={() => this.onSubscriptionModal(true)}>
                                Activate
                            </Button>
                        : user.hasOwnProperty('is_verified') && !user.is_verified ?
                            <RouterLink to={this.getVerifyUrl()} className={classes.dropdownLink}>
                                <Button className="activate-btn" color="success" size="sm">
                                    Verify
                                </Button>
                            </RouterLink>
                        :
                            null
                    }
                </DialogTitle>
                <DialogContent
                    id="processingModal-modal-slide-description"
                    className={classes.modalBody}
                >
                    <p className='text-content mb-0'><span>You're currently on a 7-day trial.</span></p>
                    <p className='text-content mb-0'>During this time, you can send messages to <span>up to 5 recipients per message</span> and <span>50 recipients per day</span>.</p>
                    <p className='text-content mb-0'>To unlock higher sending limits and gain full access to all features, you’ll need to <span>complete both activation and verification</span> steps:</p>
                    <div className='list-items'>
                        <p className='text-content'><span>Activate:</span> Ends your trial immediately, processes your credit card via Chargebee, and upgrades your account. To activate, click the <span>Activate</span> link in the top right corner or navigate to the <span>Billing</span> section under <span>Account Management</span>.</p>
                        <p className='text-content'><span>Verify:</span> Requires you to complete your contact details, enable <span>two-factor authentication (2FA)</span>, and may involve a phone call for identity verification.</p>
                    </div>
                    <p className='text-content'><span>Note:</span> Both <span>Billing</span> and <span>Security Verification</span> must be completed to unlock full access.</p>
                </DialogContent>
                <DialogActions className={classes.modalFooter+" "+classes.justifyContentCenter}>
                    <Button color="custom" onClick={() => this.props.onClose()}>
                        Close
                    </Button>
                </DialogActions>
                {
                    subscriptionModal ?
                        <ConfirmationModal 
                            open={subscriptionModal} 
                            onClose={() => this.onSubscriptionModal(false)} 
                            onSuccess={() => this.subscriptionTrialEnd()}
                            confirmationMessage="Are you sure you want to activate your account now? Activating will end your trial immediately, process your credit card payment via Chargebee, and upgrade your account."
                            successMessage={"Activation Successful"}
                            cancelButtonText={"Cancel"}
                            successButtonText={"Activate"}
                            saving={activateSaving}
                            success={subscriptionUserData === null ? false : true}
                            showError={showSubscriptionError}
                            errorMessage={errorMessage}
                        />
                    :
                        <></>
                }
            </Dialog>
        )
    }
}

SendLimitModal.defaultProps = {
    open: false,
    saving: false,
    errorMessage: null,
}
SendLimitModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    saving: PropTypes.bool,
    errorMessage: PropTypes.string
}
export default withStyles(sendLimitModalStyle)(SendLimitModal);